<template>
  <div>
    <!-- {{ security }} -->
    <div class="tradingview-widget-container-ta">
      <div class="tradingview-widget-container__widget"></div>
      <div class="tradingview-widget-copyright"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["exchange", "symbol", "height"],
  mounted() {
    // console.log(
    //   this.symbol,
    //   this.exchange,
    //   "*******************************************"
    // );
    let container = document.getElementsByClassName(
      "tradingview-widget-container-ta"
    )[0];
    // container.replaceChildren();
    const script = document.createElement("script");
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = JSON.stringify({
      interval: "1m",
      width: "100%",
      // height: "399",
      height: `${this.height}`,
      border: "0",
      isTransparent: false,
      // symbol: "BSE:TATACHEM",
      symbol: `${this.exchange}:${this.symbol}`,

      showIntervalTabs: true,
      locale: "in",
      colorTheme: "light",
    });
    container.appendChild(script);
  },
};
</script>

<style lang="scss">
::v-deep
  html
  > body
  div.tv-embed-widget-wrapper
  > .tv-embed-widget-wrapper__body {
  border: none !important;
}

.tv-embed-widget-wrapper
  >>> .tv-embed-widget-wrapper__body
  .js-embed-widget-body {
  border: none !important;
}
</style>
